export enum MemberExportFormatEnum {
  CSV = 'csv',
  AddressLabels = 'addresslabels',
  MemberList = 'memberlist',
}
